import { render, staticRenderFns } from "./TipsView.vue?vue&type=template&id=6bfe5af0&"
import script from "./TipsView.vue?vue&type=script&lang=js&"
export * from "./TipsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports